import { SearchItem } from '../../../../models/search-item';
import {
  addWkfSupervisionSearchItemFailedAction,
  addWkfSupervisionSearchItemsFailedAction,
  addWkfSupervisionSearchItemsStartAction,
  addWkfSupervisionSearchItemsSucceededAction,
  addWkfSupervisionSearchItemStartAction,
  addWkfSupervisionSearchItemSucceededAction,
  removeAllWkfSupervisionSearchItemsSucceededAction,
  removeWkfSupervisionSearchItemFailedAction,
  removeWkfSupervisionSearchItemStartAction,
  removeWkfSupervisionSearchItemSucceededAction,
  setWkfSupervisionSearchItemsFailedAction,
  setWkfSupervisionSearchItemsStartAction,
  setWkfSupervisionSearchItemsSucceededAction
} from '../action/wkf-supervision-search-items.action';
import { createReducer, on } from '@ngrx/store';
import * as _ from 'lodash';


export interface WkfSupervisionSearchItemsState {
  datas: SearchItem[];
  loading: boolean;
  error: any;
}

export const WKF_SUPERVISION_SEARCH_ITEMS_INITIAL_STATE: WkfSupervisionSearchItemsState = {
  datas: [],
  loading: false,
  error: null,
};


export const wkfSupervisionSearchItemsReducer = createReducer(
  WKF_SUPERVISION_SEARCH_ITEMS_INITIAL_STATE,
  on(addWkfSupervisionSearchItemStartAction, (state) => ({
    ...state,
    loading: true,
    error: null,
  })) ,
  on(addWkfSupervisionSearchItemSucceededAction, (state, {payload}) => {
    const item: SearchItem = _.cloneDeep(payload);
    const size = state.datas.length;
    const lastItemId = state.datas.length ? state.datas[state.datas.length - 1].id : 0;

    if (item.id === -1) {
      item.id = size > lastItemId ? size : lastItemId + 1;
      return {
        ...state,
        datas: state.datas.concat(item),
        loading: false,
        error: null,
      };
    } else {
      const itemIndex = state.datas.findIndex((stateItem) => stateItem.id === item.id);
      const datasCopy = _.cloneDeep(state.datas);
      datasCopy.splice(itemIndex, 1, item);
      return {
        ...state,
        datas: datasCopy,
        loading: false,
        error: null,
      };
    }
  }),

  on(addWkfSupervisionSearchItemFailedAction, (state, {error}) => ({
    ...state,
    datas: [],
    loading: false,
    error: error,
  })) ,
  on(removeWkfSupervisionSearchItemStartAction, (state) => ({
    ...state,
    loading: true,
    error: null,
  })) ,
  on(removeWkfSupervisionSearchItemSucceededAction, (state, {payload}) => {
    const copy = state.datas.filter(oneItem => {
      return oneItem.id !== payload.id;
    });
    return ({
      ...state,
      datas: copy,
      loading: false,
      error: null,
    })
  }) ,
  on(removeWkfSupervisionSearchItemFailedAction, (state, {error}) => ({
    ...state,
    datas: [],
    loading: false,
    error: error,
  })) ,
  on(removeAllWkfSupervisionSearchItemsSucceededAction, (state) => ({
    ...state,
    datas: [],
    loading: false,
    error: null
  })) ,
  on(addWkfSupervisionSearchItemsStartAction, (state) => ({
    ...state,
    loading: true,
    error: null,
  })) ,
   on(addWkfSupervisionSearchItemsSucceededAction, (state, {payload}) => {
    const items: SearchItem[] = _.cloneDeep(payload);
    const size = state.datas.length;
    const lastItemId = state.datas.length ? state.datas[state.datas.length - 1].id : 0;
    const datasCopy = _.cloneDeep(state.datas);

    items.forEach( (item) => {
     if (item.id === -1) {
       item.id = size > lastItemId ? size : lastItemId + 1;
       datasCopy.push(item);
     } else {
       const itemIndex = state.datas.findIndex((stateItem) => stateItem.id === item.id);
       datasCopy.splice(itemIndex, 1, item);
     }

    });

    return {
      ...state,
      datas: datasCopy,
      loading: false,
      error: null,
    };

  }),
  on(addWkfSupervisionSearchItemsFailedAction, (state, {error}) => ({
    ...state,
    datas: [],
    loading: false,
    error: error,
  })) ,
  on(setWkfSupervisionSearchItemsStartAction, (state) => ({
    ...state,
    loading: true,
    error: null,
  })) ,
  on(setWkfSupervisionSearchItemsSucceededAction, (state, {payload}) => {
    const items: SearchItem[] = _.cloneDeep(payload);
    const newDatas = [];

    items.forEach( (item) => {
      item.id = newDatas.length+1;
      newDatas.push(item);
    });

    return {
      ...state,
      datas: newDatas,
      loading: false,
      error: null,
    };

  }),

  on(setWkfSupervisionSearchItemsFailedAction, (state, {error}) => ({
    ...state,
    datas: [],
    loading: false,
    error: error,
  })) ,
);
